import React from "react";
import { Money } from "../../../components";
import { Icon, IconButton } from "../../../components/ui";
import RemovePriceConfirm from "./RemovePriceConfirm";

import { monthLabels, boxLabels } from "../../constants";
import { sourceOptions } from "../../constants";
import dayjs from "dayjs";
import useTradeImage from "./useTradeImage";

const ucFirst = (string) => {
  return string ? string[0].toUpperCase() + string.substring(1) : string;
};

const convertString = (string) => {
  let arr;
  try {
    arr = JSON.parse(string);
  } catch (_) {
    return undefined; // missing/blank/non-JSON — render nothing
  }
  if (arr && arr.length > 0) {
    return arr.join(",");
  }
};

const formatDateAsDaysAgo = (dateString) => {
  if (!dateString) {
    return "Today";
  }

  const daysDiff = dayjs().diff(dayjs(dateString), "day");

  if (daysDiff === 0) {
    return "Today";
  } else if (daysDiff === 1) {
    return "1 day ago";
  } else {
    return `${daysDiff} days ago`;
  }
};

const AvailablePriceItem = ({
  item,
  removeItem,
  isRemoving,
  setIsRemoving,
}) => {
  const tradeImage = useTradeImage(item);
  const year = item?.year_month?.substr(0, 4);
  const month = item?.year_month?.substr(5, 2);
  const monthLabel = monthLabels?.[month * 1];
  const locationName = item?.location?.replace("-e", " E").replace("uk", "UK");

  const getSourceName = (source) => {
    return sourceOptions.find((option) => option.id === source)?.name;
  };

  return (
    <>
      <tr
        key={item.id}
        className="price-list"
        style={{ backgroundColor: `${item.under_priced ? "#A4E6A0" : ""}` }}
      >
        <td></td>
        <td className="price-list__thumb">
          {tradeImage.src ? (
            <img src={tradeImage.src} alt="" loading="lazy" />
          ) : tradeImage.showPlaceholder ? (
            <span className="price-list__no-photo">No photo</span>
          ) : null}
        </td>
        <td>{formatDateAsDaysAgo(item?.price_date)}&nbsp;</td>
        <td>{getSourceName(item?.source)}&nbsp;</td>
        <td>
          {monthLabel ? `${monthLabel} ` : ""}
          {year}&nbsp;
        </td>
        <td>{convertString(item?.condition)}&nbsp;</td>
        <td>
          <IconButton
            variant="ghost"
            size="sm"
            label="Open listing"
            data-btn="price-open"
            disabled={!item?.listing_link}
            href={item?.listing_link}
            target="_blank"
          >
            <Icon name="ExternalLink" size="sm" />
          </IconButton>
        </td>
        <td>
          <Money
            amount={parseInt(item?.gbp_price / 100) * 100}
            currency="gbp"
            style={{ fontSize: "14px" }}
          />
          &nbsp; &nbsp;
        </td>
        <td>{boxLabels?.[item?.box]}&nbsp;</td>
        <td>
          {item.supplier_id ? item.supplier_name : item.supplier}
          &nbsp;
        </td>
        <td>{item.store_name}&nbsp;</td>
        <td>{ucFirst(locationName)}&nbsp;</td>
        <td>
          <IconButton
            variant="ghost"
            size="sm"
            label="Remove price"
            data-btn="price-delete"
            onClick={() => setIsRemoving(true)}
          >
            <Icon name="Trash2" size="sm" />
          </IconButton>
        </td>
      </tr>

      <RemovePriceConfirm
        inlineRow
        isOpen={isRemoving}
        onCancel={() => setIsRemoving(false)}
        onRemove={() => removeItem(item.id)}
      />
    </>
  );
};

export default AvailablePriceItem;
